const constants = {
    ArvadaSupportUrl: 'https://support.arvadacenter.org'
    // ArvadaSupportUrl: 'https://test-na-arva.tn.services'
}

export default constants;